import { z } from 'zod/v3'

import { m } from '@/lib/paraglide/messages'

export function createInvoiceSettingsSchema() {
    return z.object({
        company_name: z.string().min(1, m.validation_invoice_company_name()),
        company_address: z
            .string()
            .min(1, m.validation_invoice_company_address()),
        company_phone: z.string().min(1, m.validation_invoice_company_phone()),
        company_tax_code: z.string().optional(),
        bank_name: z.string().optional(),
        bank_account: z.string().optional(),
        bank_holder: z.string().optional(),
        footer_note: z.string().optional(),
        vat_percent: z.coerce.number().min(0).max(100),
        misa_ip_template_id: z.string(),
        misa_inv_series: z.string(),
    })
}

export type InvoiceSettingsFormData = z.infer<
    ReturnType<typeof createInvoiceSettingsSchema>
>
